import { defineComponent as _defineComponent } from 'vue'
import { ObjectType } from '@/@types/graphql-types';
import { TitleOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';
import BuyBoxOfferNewPresentation from '@/components/experiments/OverProviderExp/components/BuyBoxOfferNewPresentation.vue';
import { useI18n } from '@/helpers/composables/useI18n';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { BuyBoxFilterOptions, NewBuyBoxView } from '@/stores/useUserStoreTypes';
import { computed, defineAsyncComponent } from 'vue';
import { PlanOffer } from '@/features/buybox/composables/useFreeTrial';
import { useOverProviderExp } from '@/components/experiments/OverProviderExp';
import { getDisclaimerText } from '@/features/buybox/helpers/list-buybox-config';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromotionRowOfferPresentation',
  props: {
    title: null,
    promotionOffer: null,
    packagePlan: null,
    isFallback: { type: Boolean },
    isHighlighted: { type: Boolean },
    filterOption: null,
    buyboxView: { default: NewBuyBoxView.LIST }
  },
  setup(__props: any) {

const props = __props as { title: TitleDetail, promotionOffer: TitleOfferFragment | null, packagePlan: PlanOffer | null, isFallback?: boolean, isHighlighted?: boolean, filterOption?: BuyBoxFilterOptions, buyboxView: NewBuyBoxView };

const DisclaimerButton = defineAsyncComponent(() => import('@/features/buybox/components/DisclaimerButton.vue'));



const { tc, t } = useI18n();

const { isOverProviderTitle } = useOverProviderExp({
	promotionOffer: () => props.promotionOffer,
});

const subText = computed(() => {
	if (!props.promotionOffer) return '';

	const provider = props.promotionOffer?.package.clearName;

	if (!props.isFallback) {
		return t('WEBAPP_FREE_TRIAL_TEXT', { provider });
	}

	return props.title.objectType === ObjectType.Movie
		? t('WEBAPP_WATCH_SIMILAR_MOVIES_FREE_ON_X', { provider })
		: t('WEBAPP_WATCH_SIMILAR_TV_SHOWS_FREE_ON_X', { provider });
});

const highlightedCTAText = computed(() => {
	if (props.title.__typename === 'Show' || props.title.__typename === 'Season') return tc('WEBAPP_OTHER_SHOWS');
	if (props.title.__typename === 'Movie') return tc('WEBAPP_OTHER_MOVIES');
	return '';
});

const disclaimerText = computed(() => {
	if (!props.promotionOffer) return null;

	return getDisclaimerText(props.promotionOffer.package.shortName, props.promotionOffer.country);
});

const showDisclaimerButton = computed(() => {
	if (!!disclaimerText.value) return true;
	return props.promotionOffer?.package.packageId === 350 && props.packagePlan?.retailPrice;
});

return { __sfc: true,DisclaimerButton, props, tc, t, isOverProviderTitle, subText, highlightedCTAText, disclaimerText, showDisclaimerButton, BuyBoxOfferNewPresentation, NewBuyBoxView }
}

})